import {all, call, put, takeEvery} from 'redux-saga/effects';
import {stopSubmit} from 'redux-form/immutable';
import {notify} from 'common/notify';

import * as action from '../actions';
import * as dataContext from '../dataProvider/dataContext';

function* sendFindFormSaga({form, onFailure}) {
	try {
		const response = yield call(dataContext.sendCardFindForm, form);
		yield put(action.findCard.success({response}));
	} catch (err) {
		yield put(action.findCard.failure({errors: err.response.data}));

		if (err.response.data) {
			const errors = err.response.data.reduce((errors, error) => {
				return {...errors, ...{_error: error.message}};
			}, {});
			yield put(stopSubmit('cardFindForm', errors));
		}
		yield put(notify.error('При отправке формы произошла ошибка'));

		onFailure && onFailure();
	}
}

function* sendCreateFormSaga({form, onFailure}) {
	try {
		const response = yield call(dataContext.sendCardCreateForm, form);
		yield put(action.findCard.success({response}));
	} catch (err) {
		yield put(action.findCard.failure({errors: err.response.data}));

		if (err.response.data) {
			const errors = err.response.data.reduce((errors, error) => {
				return {...errors, ...{_error: error.message}};
			}, {});
			yield put(stopSubmit('cardCreateForm', errors));
		}
		yield put(notify.error('При отправке формы произошла ошибка'));

		onFailure && onFailure();
	}
}

export default function* sagas() {
	return yield all([
		takeEvery(action.findCard.request, sendFindFormSaga),
		takeEvery(action.createCard.request, sendCreateFormSaga),
	]);
}



// WEBPACK FOOTER //
// ./src/sagas/cardSaga.js